<template>
  <div v-show="state.application" :class="''">
    <div class="content">
      <div class="sideContent">
        <alerts name="alerts"/>
      </div>
      <div v-if="state.application" class="mainContent">
        <ApplicationViewHeader />
        <nav-bar name="previous" />
        <Summary />
        <div v-if="state.application" class="card">
          <template>
            <EaForm />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import ApplicationViewHeader from '@/views/ApplicationViewHeader.vue'
import NavBar from '@/components/application/NavBar.vue'
import EaForm from '@/components/application/ea/form/Form.vue'
import Summary from '@/components/application/Summary.vue'
export default {
  name: 'ApplicationView',
  components: {
    ApplicationViewHeader,
    EaForm,
    NavBar,
    Summary
  },  
  computed: {
    state() {
      return this.$store.state
    },
    isDirty() {
      return false
    }, 
    application() {
      return ''//state.application
    },    
  },
  methods: {
    loadApplication(id) {
      if (!id ) {
        id = this.$route.params.id
      }
      this.$store.dispatch('set', ['sectionExpandedId', null]) // Collapse sections when opening an application
      this.$store.dispatch('getApplication', [id]).then(() => {
       //fo nothings
      })
    },    
  },
  mounted() {
    this.loadApplication()
    // Warn if trying to navigate away with unsaved data
    var me = this
    window.onbeforeunload = function (e) {
      if (me.isDirty) {
        e.preventDefault()
        return ''
      }
    }
  },
  // Necessary when switching between different applications
  beforeRouteUpdate(to, from, next) {
    this.loadApplication(to.params.id)
    next()
  }
}
</script>

<style scoped lang="scss">
  $header-height: 64px;
  
  .card {
    background-color: white;
  }
  .content,
  .sideContent,
  .mainContent {
    background-color: #f5f5f5;
  }
  .sideContent {
    padding: 1rem;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    background-color: white;
  }
  
  // Desktop layout shows Actions as a left sidebar
  @include desktop {
    .content {
      height: 100%;
      width: 100%;
    }
    .card {
      margin: 0 3rem;
    }
    .content,
    .mainContent {
      position: absolute;
    }
    .sideContent {
      position: fixed;
      height: calc(100% - #{$header-height});
      overflow-x: hidden;
      overflow-y: auto;
      top: $header-height;
      left: 0;
      width: $desktop-sidebar-width;
      padding: 1rem 1rem 1rem 2rem;
      border-bottom: 0;
    }
    .mainContent {
      top: 0;
      left: $desktop-sidebar-width;
      width: calc(100% - #{$desktop-sidebar-width});
    }
  
    .isEditing .sideContent {
      padding-bottom: $save-bar-height; // Extra padding for when save bar is visible, so bottom content can be reached
    }
  
    .isEditing .mainContent {
      padding-bottom: $save-bar-height;
    }
    .clear {
      clear: both;
    }
  }
  </style>